export enum CookieEnums {
    BasketSessionId = 'lobbasket',
    CookieConsent = 'lobconsent',
    RecentlyViewedIds = 'lob_viewed_products',
    NotificationStatus = 'lobnotificationstatus',
    NotificationTriggerCount = 'lobnotificationcount',
    AffiliateClickRef = 'lobaffiliateclickref'
}
